export enum DocumentRequestEventNameEnum {
  DOCUMENT_REQUEST_CREATED = 'DOCUMENT_REQUEST_CREATED',
  DOCUMENT_REQUEST_SEEN_BY_CANDIDATE = 'DOCUMENT_REQUEST_SEEN_BY_CANDIDATE',
  DOCUMENT_REQUEST_READY_TO_REVIEW = 'DOCUMENT_REQUEST_READY_TO_REVIEW',
  DOCUMENT_REQUEST_APPROVED = 'DOCUMENT_REQUEST_APPROVED',
  DOCUMENT_REQUEST_CANCELED = 'DOCUMENT_REQUEST_CANCELED',
  DOCUMENT_REQUEST_DELETED = 'DOCUMENT_REQUEST_DELETED',
  DOCUMENT_REQUEST_RESULT_DOWNLOADED = 'DOCUMENT_REQUEST_RESULT_DOWNLOADED',

  DOCUMENT_SEND_TO_SUBSCRIPTION_SUCCESS = 'DOCUMENT_SEND_TO_SUBSCRIPTION_SUCCESS',
  DOCUMENT_SEND_TO_SUBSCRIPTION_FAIL = 'DOCUMENT_SEND_TO_SUBSCRIPTION_FAIL',
  DOCUMENT_REQUESTED = 'DOCUMENT_REQUESTED',
  DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
  DOCUMENT_APPROVED = 'DOCUMENT_APPROVED',
  DOCUMENT_REJECTED = 'DOCUMENT_REJECTED',
  DOCUMENT_ARCHIVED = 'DOCUMENT_ARCHIVED',
  DOCUMENT_DELETED = 'DOCUMENT_DELETED',

  DOCUMENT_DETAILS_UPDATED = 'DOCUMENT_DETAILS_UPDATED',

  DOT_MEDICAL_VERIFICATION_FILE_UPLOADED = 'DOT_MEDICAL_VERIFICATION_FILE_UPLOAD',
  DOCUMENT_REQUEST_SMS_STATUS_CHANGED = 'DOCUMENT_REQUEST_SMS_STATUS_CHANGED',
  DOCUMENT_REQUEST_SMS_ERROR = 'DOCUMENT_REQUEST_SMS_ERROR',
  DOCUMENT_REQUEST_SMS_DELIVERED = 'DOCUMENT_REQUEST_SMS_DELIVERED',

  DOCUMENT_APPROVED_SMS_STATUS_FAILED = 'DOCUMENT_APPROVED_SMS_STATUS_FAILED',
  DOCUMENT_APPROVED_SMS_STATUS_DELIVERED = 'DOCUMENT_APPROVED_SMS_STATUS_DELIVERED',
}
